import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Box, Card, CardContent, CardHeader, Grid, Tab, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import PageHeader from "../../../../materio/@core/components/page-header";
import { AIRole, AITone } from "../ai-chat-types";
import AIRoleSelector from "../components/AIRoleSelector";
import AIToneSelector from "../components/AIToneSelector";
import PromptCompletion from "../components/PromptCompletion";

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

const ChatPlayground = () => {
    const [selectedRoleId, setSelectedRoleId] = useState<string>(EMPTY_GUID)
    const [selectedRole, setSelectedRole] = useState<AIRole | undefined>(undefined)
    const [constraint, setConstraint] = useState<string>('')
    const [selectedToneId, setSelectedToneeId] = useState<string>(EMPTY_GUID)
    const [selectedTone, setSelectedTone] = useState<AITone | undefined>(undefined)
    const [value, setValue] = useState('1');
    const [prompt, setPrompt] = useState('');

    useEffect(() => {
        if (selectedRole) setSelectedRoleId(selectedRole.id);
    }, [selectedRole])

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <Card>
            <CardContent>
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            title={<Typography variant='h5'>Chat Prompt Builder</Typography>}
                            subtitle={
                                <Typography variant='body2'>
                                    Create and engineer the perfect prompt.
                                </Typography>
                            }
                        />
                    </Grid>
                </Grid>
            </CardContent>
            <CardContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 5 }}>
                    <Grid container spacing={2}>
                        <AIRoleSelector
                            selectedRoleId={selectedRoleId}
                            onChange={(updatedRole: AIRole | undefined) => { setSelectedRole(updatedRole) }}
                        />

                        <AIToneSelector
                            selectedToneId={selectedToneId}
                            onChange={(updatedTone: AITone | undefined) => { setSelectedTone(updatedTone) }}
                        />
                    </Grid>

                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="lab API tabs example">
                                <Tab label="Manual" value="1" />
                                <Tab label="Library" value="2" />
                            </TabList>
                        </Box>
                        <TabPanel value="1">
                            <TextField multiline fullWidth rows={8} label="Prompt" value={prompt} onChange={(e) => setPrompt(e.target.value)} />
                        </TabPanel>
                        <TabPanel value="2">
                            <Typography variant="h6">Constraints</Typography>

                            <PromptCompletion prompt={"The tweet should use no more than %token% emojis and target %token%. It should highlight two advantages of %token%"} onChange={(newPrompt: string) => setConstraint(newPrompt)} />
                        </TabPanel>
                    </TabContext>

                    <Card sx={{ minWidth: 275 }}>
                        <CardContent>
                            <Typography variant="h6">Final Prompt</Typography>


                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                                {selectedRole && <Typography variant="body1">{selectedRole.prompt}</Typography>}

                                <Typography variant="body1">{prompt}</Typography>

                                <Typography variant="body1">{constraint}</Typography>

                                {selectedTone && <Typography variant="body1">Please make it {selectedTone.tone}</Typography>}
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            </CardContent>
        </Card>
    )
}

ChatPlayground.guestGuard = false;
ChatPlayground.authGuard = true;

export { ChatPlayground }
export default ChatPlayground;